import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { GenericCDataLinkedService } from '../linkedservice/generic-cdata.linkedservice';
import { ModelConstants } from '../model-constants';
import { TabularTypeDataset } from './tabular-type.dataset';

@Metamodel.model({
    name: ModelConstants.genericCDataTableDataset,
    display: [],
    constraints: {
        linkedService: {
            model: GenericCDataLinkedService.MODEL
        }
    }
})
export class GenericCDataTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
